import authSaga from '~/sagas/auth/auth.saga';

export default authSaga;
